export default class Helper {
    static infoMessage(
        thisObj,
        variant = "success",
        message = "This is message"
    ) {
        thisObj.$root.$bvToast.toast(
            message.charAt(0).toUpperCase() + message.slice(1),
            {
                title:
                    variant != ""
                        ? variant.charAt(0).toUpperCase() + variant.slice(1)
                        : "",
                variant: variant == "error" ? "danger" : variant,
                solid: true,
            }
        );
    }
}